const XIcon = () => {
    return(
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.125 14.875L7.47177 9.52823M14.875 2.125L9.52823 7.47177M9.52823 7.47177L5.66667 2.125H2.125L7.47177 9.52823M9.52823 7.47177L14.875 14.875H11.3333L7.47177 9.52823" stroke="#30970B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

export default XIcon